import { useState, useEffect, useCallback } from "react";
import { fetchTattvaRelated, libraryGraphKey } from "@/lib/tattva/tattva-api";

/**
 * Load published tattva graph around a node id or library topic (type + libraryId).
 */
export function useTattvaGraph(idOrType, libraryId) {
  const anchorId =
    libraryId != null && typeof idOrType === "string"
      ? libraryGraphKey(idOrType, libraryId)
      : idOrType;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    if (!anchorId) {
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const related = await fetchTattvaRelated(anchorId);
      setData(related);
    } catch (e) {
      setData(null);
      setError(e?.response?.data?.detail || "Could not load tattva graph");
    }
    setLoading(false);
  }, [anchorId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, reload, anchorId };
}
